exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".text-align-center___1_j2N {\n  text-align: center;\n}\n.paragraph-margin___2n1Bm {\n  margin: 20px 0 0 0;\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/causefundraisernodeweb-ci-release/public/js/components/Module.less"],"names":[],"mappings":"AAAA;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;CACpB","file":"Module.less","sourcesContent":[".text-align-center {\n  text-align: center;\n}\n.paragraph-margin {\n  margin: 20px 0 0 0;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"text-align-center": "text-align-center___1_j2N",
	"paragraph-margin": "paragraph-margin___2n1Bm"
};